import { useState } from 'react'
import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTitle,
} from '@/components/ui/sheet'
import { AllocationForm } from './AllocationForm'
import { useCreateAllocation, useUpdateAllocation } from '@/hooks/useAllocations'
import type { AllocationTableRow, AllocationFormData } from '@/types/allocations'

interface AllocationDrawerProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  allocation?: AllocationTableRow
}

export function AllocationDrawer({
  open,
  onOpenChange,
  allocation,
}: AllocationDrawerProps) {
  const [isSubmitting, setIsSubmitting] = useState(false)
  const createMutation = useCreateAllocation()
  const updateMutation = useUpdateAllocation()

  const handleSubmit = async (data: AllocationFormData) => {
    setIsSubmitting(true)
    try {
      if (allocation) {
        await updateMutation.mutateAsync({
          id: allocation.id,
          data,
        })
      } else {
        await createMutation.mutateAsync(data)
      }
      onOpenChange(false)
    } finally {
      setIsSubmitting(false)
    }
  }

  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent className="max-h-[90vh] overflow-y-auto">
        <SheetHeader>
          <SheetTitle>
            {allocation ? 'Edit Allocation' : 'Create Allocation'}
          </SheetTitle>
          <SheetDescription>
            {allocation
              ? `Update allocation for aircraft ${allocation.tail_number || 'Unknown'}`
              : 'Create a new aircraft allocation'}
          </SheetDescription>
        </SheetHeader>
        <div className="overflow-y-auto px-4 pb-4">
          <AllocationForm
            allocation={allocation}
            onSubmit={handleSubmit}
            isLoading={isSubmitting}
          />
        </div>
      </SheetContent>
    </Sheet>
  )
}
